import React, { useEffect, useRef, useState } from 'react';
import './Login.css';
import logo from './logotechdoggroupmetpayoff.png';
import { useNavigate } from 'react-router-dom';
import sales from '../Sales';
import Cookies from 'universal-cookie';
import dayjs from 'dayjs';

const Login = () => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [checkingSession, setCheckingSession] = useState(true);
  const navigate = useNavigate();
  const cookies = new Cookies();
  const inputRef = useRef(null);
  const time = dayjs();

  const options = {
    path: '/',
    maxAge: 48000 * 48000, // valid for a bit longer than 1 year
  };

  const goToStartPage = (isAdmin) => {
    if (isAdmin == 1) {
      navigate('admin');
    } else {
      navigate(`dashboard/${time.month() + 1}/${time.year()}`);
    }
  };

  // Onbekende/lege foutrespons mag geen leeg foutvak opleveren.
  const readError = (err) =>
    err?.response?.data?.error || 'Inloggen mislukt. Probeer het opnieuw.';

  useEffect(() => {
    if (!cookies.get('token')) {
      setCheckingSession(false);
      return;
    }
    (async () => {
      try {
        const res = await sales.get(`login?ApiKey=${cookies.get('token')}`);
        goToStartPage(res.data.admin);
      } catch (err) {
        cookies.remove('token', { path: '/' });
        console.warn(err.response);
        setCheckingSession(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (!checkingSession) {
      inputRef.current?.focus();
    }
  }, [checkingSession]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!password || loading) return;

    setLoading(true);
    setError('');
    try {
      const res = await sales.get(`login?password=${encodeURIComponent(password)}`);
      cookies.set('token', res.data.ApiKey, options);
      goToStartPage(res.data.admin);
    } catch (err) {
      console.warn(err.response);
      setError(readError(err));
      setLoading(false);
      inputRef.current?.select();
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={logo} className="login-logo" alt="TechDog Group" />
        <h1 className="login-title">Sales Dashboard</h1>
        <p className="login-subtitle">Voer het wachtwoord in om verder te gaan.</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div>
            <label className="login-label" htmlFor="password">
              Wachtwoord
            </label>
            <div className={`login-field${error ? ' has-error' : ''}`}>
              <input
                ref={inputRef}
                className="login-input"
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                placeholder="••••••••"
                autoComplete="current-password"
                disabled={checkingSession || loading}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error) setError('');
                }}
              />
              <button
                type="button"
                className="login-reveal"
                onClick={() => setShowPassword((v) => !v)}
                tabIndex={-1}
              >
                {showPassword ? 'Verberg' : 'Toon'}
              </button>
            </div>
          </div>

          {error && <div className="login-error">{error}</div>}

          <button
            type="submit"
            className="login-button"
            disabled={!password || loading || checkingSession}
          >
            {loading ? 'Inloggen…' : 'Inloggen'}
          </button>
        </form>

        <p className="login-footer">TechDog Group — Sales Dashboard</p>
      </div>
    </div>
  );
};

export default Login;
